import { has, map } from 'lodash';

import { SelectOption } from '@geniuspos/ui-shared';
import { I18n } from '../strings-keys';

export const FILTER_TRANSLATION_HASH_MAP: Record<string, string> = {
  containsAny: I18n.Common.AnyOfTheFollowing,
  containsAnyString: I18n.Common.AnyOfTheFollowingString,
  directlyEqual: I18n.Common.ItemThatDirectlyEqualWithCondition,
  isEqual: I18n.Common.ExactValue,
  containsAll: I18n.Common.AllOfTheFollowing,
  notContains: I18n.Common.NoneOfTheFollowing,
  equals: I18n.Common.Date,
  inRangeDate: I18n.Common.DateRange,
  equalsPrice: I18n.Common.Amount,
  inRangePrice: I18n.Common.Range,
  mappings: I18n.Common.Mappings,
  greaterThan: I18n.Common.GreaterThan,
  lessThan: I18n.Common.LessThan,
  greaterThanOrEqual: I18n.Common.GreaterThanOrEqual,
  lessThanOrEqual: I18n.Common.LessThanOrEqual,
  inRange: I18n.Common.InRange,
};

export const mapTextEnumsValueForFilterOption = (
  filterOption: SelectOption[],
  overrideOptionsMap?: Record<string, string>,
): SelectOption[] =>
  map(filterOption, (option) => {
    if (!has(option, 'text') && !has(option, 'value')) return option;

    return {
      ...option,
      text:
        overrideOptionsMap?.[option.value] ||
        FILTER_TRANSLATION_HASH_MAP[option.value] ||
        option.text,
    };
  });
